import React from "react";
import ReactApexChart from "react-apexcharts";

export const ProjectCharts = ({ type, data }) => {
  const { timeSeries, label } = (() => {
    const sources = {
      MSI: ["NDVI", "NDWI", "NDMI", "NDRE", "CIG", "CIRedEdge"],
      SAR: ["RVI"],
      Weather: [
        "Temperature_Air_2m_Min_24h",
        "Temperature_Air_2m_Max_24h",
        "Precipitation_Flux",
        "Wind_Speed_10m_Mean",
        "Relative_Humidity_2m_06h",
        "Solar_Radiation_Flux",
      ],
    };

    const indiceOptions = {
      MSI: [
        { label: "NDVI", value: "NDVI" },
        { label: "NDMI", value: "NDMI" },
        { label: "NDRE", value: "NDRE" },
        { label: "NDWI", value: "NDWI" },
        { label: "CIG", value: "CIG" },
        { label: "CIRedEdge", value: "CIRedEdge" },
      ],
      SAR: [{ label: "RVI", value: "RVI" }],
      Weather: [
        { label: "Min Temperature", value: "Temperature_Air_2m_Min_24h" },
        { label: "Max Temperature", value: "Temperature_Air_2m_Max_24h" },
        { label: "Precipitation", value: "Precipitation_Flux" },
        { label: "Wind Speed", value: "Wind_Speed_10m_Mean" },
        { label: "Relative Humidity", value: "Relative_Humidity_2m_06h" },
        { label: "Solar Radiation", value: "Solar_Radiation_Flux" },
      ],
    };

    let resolvedType = type;
    let resolvedLabel = "";

    outer: for (const [group, options] of Object.entries(indiceOptions)) {
      for (const opt of options) {
        if (opt.value === type || opt.label === type) {
          resolvedType = opt.value;
          resolvedLabel = opt.label;
          break outer;
        }
      }
    }

    for (const [group, types] of Object.entries(sources)) {
      if (types.includes(resolvedType)) {
        const seriesData = data?.data?.[group]?.[resolvedType]?.TIMESERIES;
        if (Array.isArray(seriesData)) {
          const timeSeries = seriesData.map((item) => ({
            x: item.date,
            y: item[`${resolvedType}_MEAN`] ?? null,
          }));
          return { timeSeries, label: resolvedLabel || resolvedType };
        }
      }
    }

    return { timeSeries: [], label: "" };
  })();

  // let timeSeries = [];
  // if (type === "NDVI") {
  //   timeSeries = data?.data?.MSI?.NDVI?.TIMESERIES.map(item => ({
  //     x: item.date,
  //     y: item.NDVI_MEAN,
  //   }));
  // } else if (type === "NDWI") {
  //   timeSeries = data?.data?.MSI?.NDWI?.TIMESERIES.map(item => ({
  //     x: item.date,
  //     y: item.NDWI_MEAN,
  //   }));
  // } else if (type === "Temperature_Air_2m_Min_24h") {
  //   timeSeries = data?.data?.Weather?.Temperature_Air_2m_Min_24h?.TIMESERIES.map(item => ({
  //     x: item.date,
  //     y: item.Temperature_Air_2m_Min_24h_MEAN,
  //   }));
  // } else if (type === "Temperature_Air_2m_Max_24h") {
  //   timeSeries = data?.data?.Weather?.Temperature_Air_2m_Max_24h?.TIMESERIES.map(item => ({
  //     x: item.date,
  //     y: item.Temperature_Air_2m_Max_24h_MEAN,
  //   }));
  // } else if (type === "Precipitation_Flux") {
  //       timeSeries = data?.data?.Weather?.Precipitation_Flux?.TIMESERIES.map(item => ({
  //     x: item.date,
  //     y: item.Precipitation_Flux_MEAN,
  //   }));
  // }

  const chartOptions = {
    chart: {
      type: "line",
      zoom: {
        enabled: true,
        type: "x",
        autoScaleYaxis: true,
      },
      toolbar: {
        autoSelected: "zoom",
        tools: {
          pan: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          reset: true,
        },
      },
    },
    xaxis: {
      type: "datetime",
      title: {
        text: "Date",
      },
    },
    yaxis: {
      title: {
        // text: `${type} Value`,
        text: `Value`,
      },
      decimalsInFloat: 2,
    },
    tooltip: {
      x: {
        format: "dd MMM yyyy",
      },
    },
    title: {
      text: `Time Series`,
      align: "center",
      style: {
        fontSize: "18px",
        fontWeight: "bold",
      },
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    markers: {
      size: 3,
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#00B8D9"],
  };

  const chartSeries = [
    {
      name: `${type} Mean`,
      data: timeSeries,
    },
  ];

  return (
    <div className="card mt-4 p-3 shadow-sm">
      <ReactApexChart
        options={chartOptions}
        series={chartSeries}
        type="line"
        height={350}
      />
    </div>
  );
};
